import { useEffect } from 'react';
/**
 * Disables `scrollingElement`'s scroll when `condition` is true.
 * @param condition Whether or not to disable `scrollingElement` scroll.
 */
export function useNoScroll(condition) {
    useEffect(() => {
        const { overflow } = getStyle();
        setOverflow(condition ? 'hidden' : overflow);
        return () => setOverflow(overflow);
    }, [condition]);
}
const getScrollingElement = () => document.scrollingElement || document.documentElement;
const getStyle = () => getScrollingElement().style || {};
const setOverflow = (value = '') => {
    getStyle().overflow = value;
};
//# sourceMappingURL=useNoScroll.js.map